import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheDataAnalyst = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          📊 Recruter un Data Analyst
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le Data Analyst collecte, traite et interprète les données pour produire des analyses exploitables par les équipes métier. Il joue un rôle central dans la prise de décision stratégique et opérationnelle, en transformant les chiffres en informations claires et actionnables. C’est un profil à la fois technique et orienté business, indispensable dans une démarche data-driven.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Collecter et structurer les données issues de différentes sources</li>
          <li>Réaliser des analyses descriptives et exploratoires</li>
          <li>Créer des tableaux de bord et des rapports dynamiques</li>
          <li>Identifier des tendances, corrélations et axes d’optimisation</li>
          <li>Collaborer avec les équipes produit, marketing, finance, etc.</li>
          <li>Participer à la démocratisation de la culture data en interne</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Langages : SQL, Python (Pandas), R</li>
          <li>Outils BI : Power BI, Tableau, Looker, Excel avancé</li>
          <li>Compétences statistiques et sens critique</li>
          <li>Bonne compréhension des enjeux métier</li>
          <li>Qualités de présentation et vulgarisation des résultats</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : diplômé avec bonne maîtrise des outils BI et bases de données</li>
          <li>Confirmé : expérience dans la production d’analyses pour la prise de décision</li>
          <li>Senior : capacité à accompagner des directions métiers et piloter une stratégie data</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 300–400 € / jour</li>
          <li>Confirmé : 450–600 € / jour</li>
          <li>Senior : 650–800 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheDataAnalyst;
